import React from 'react';

import {
    SideBarToModal,
} from 'reaxl';

function PurchaseWithConfidenceModal({ title, content, isShow, footer, action, size, setModalDetail }) {
    return (
        <SideBarToModal
            collapsed={!!action}
            title={title}
            content={content}
            sideBarOptions={{
                fullWidth: true,
                action,
            }}
            modalOptions={{
                scrollPanel: false,
                bsSize: size,
            }}
            show={isShow}
            onHide={() => setModalDetail({ isShow: false })}
            footerContent={footer}
        />
    );
}

export default PurchaseWithConfidenceModal;
